"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
export default function TheWarmthOfCrumbHero() {
  return <section data-section-id="223549" id="die-landkinder-von-littlereloves" className="dark bg-background text-foreground min-h-screen flex flex-col lg:flex-row relative overflow-hidden">
      {}
      <div className="w-full lg:w-[60%] h-[50vh] lg:h-screen relative overflow-hidden">
        {}
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638561/img/children_playing_meadow_pebble_mask.png" alt="Kinder spielen glücklich auf einer Blumenwiese" className="absolute inset-0 w-full h-full object-cover animate-[pulse_10s_ease-in-out_infinite] scale-105" style={{
        animationDirection: "alternate"
      }} />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent lg:hidden" />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-background/20 to-background hidden lg:block" />
        <div className="absolute inset-0 bg-black/10" /> {}
      </div>

      {}
      <div className="w-full lg:w-[40%] flex items-center justify-center p-6 sm:p-12 lg:p-16 relative z-10 -mt-24 lg:mt-0">
        <Card className="bg-card/80 backdrop-blur-md border-border/50 shadow-xl w-full max-w-lg overflow-hidden rounded-3xl">
          <CardContent className="p-8 sm:p-10 flex flex-col gap-8">
            <div className="space-y-4">
              <span className="text-secondary font-default text-sm font-bold tracking-widest uppercase bg-secondary/10 px-3 py-1 rounded-lg">
                Eröffnung Sommer 2026
              </span>
              <h1 className="font-default leading-[1.1] text-foreground font-bold !text-6xl">
                Landkinder <span className="font-serif italic text-primary block !text-5xl">LittleReLoves</span>
              </h1>
            </div>

            <p className="text-muted-foreground text-lg sm:text-xl font-default leading-relaxed">
              Kinder-Secondhand, Lieblingsstücke und Geschenkartikel. Nachhaltig und liebevoll kuratiert für kleine Abenteurer und bewusste Eltern.
            </p>

            <div className="pt-4">
              <Button asChild size="lg" className="w-full sm:w-auto bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg text-lg px-8 py-7 shadow-lg transition-all duration-300 group">
                <Link to="/ShopPage">
                  Jetzt stöbern
                  <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}